import type { Store } from 'store'

class StoreManager {
  private store?: Store

  set = (_store: Store) => { this.store = _store }
  get = () => this.store
}

const manager = () => {
  const store = new StoreManager()
  return store
}

export default manager()